<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-6">
          <div class="card-group mb-0">
            <div class="card p-4">
              <spinner ref="spinner" size="md" fixed text="Checking token" />
              <div v-if="token.status === 'invalid'" class="card-block">
                <h2>Token is expired or invalid</h2>
              </div>
              <div v-else class="card-block">
                <form @submit="resetPassword">
                  <h1>Reset password</h1>
                  <p class="text-muted">Type your new password to reset it</p>
                  <div class="input-group mb-3">
                    <span class="input-group-addon"><i class="icon-lock" /></span>
                    <input
                      v-model="newPass"
                      type="password"
                      class="form-control"
                      placeholder="New password"
                    >
                  </div>

                  <div class="input-group mb-3">
                    <span class="input-group-addon"><i class="icon-lock" /></span>
                    <input
                      v-model="newPassConfirm"
                      type="password"
                      class="form-control"
                      placeholder="Confirm new password"
                    >
                  </div>

                  <div class="input-group">
                    <button type="button" class="btn btn-primary px-4 login-btn" @click="resetPassword">
                      Reset
                      <span v-if="loading" class="btn-loader" />
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div v-if="errors" class="card card-inverse card-danger">
            <div class="card-header">
              Errors
            </div>
            <div class="card-block">
              {{ errors }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import _ from 'lodash';

export default {
  data: () => ({
    token: {
      loading: true,
      status: 'waiting', // waiting | ok | invalid
      value: null,
    },
    email: '',
    newPass: '',
    newPassConfirm: '',
    loading: false,
    errors: null,
  }),

  mounted() {
    if (localStorage.getItem(this.$config.tokenStorage.name) !== '') {
      const tokenStorage = JSON.parse(localStorage.getItem(this.$config.tokenStorage.name));
      if (!_.isEmpty(tokenStorage)) {
        this.$router.push('/admin');
      }
    }
    this.checkToken();
  },

  methods: {
    isFormValid() {
      if (!this.newPass) {
        this.errors = 'Please pass all fields.';
        return false;
      }
      if (!this.newPassConfirm) {
        this.errors = 'Please pass all fields.';
        return false;
      }
      if (this.newPass.length < 6 || this.newPassConfirm.length < 6) {
        this.errors = 'Password should contain at least 6 symbols.';
        return false;
      }
      if (this.newPassConfirm !== this.newPass) {
        this.errors = 'Passwords fields are not equal.';
        return false;
      }
      return true;
    },
    checkToken() {
      if (!this.$route.params.token) this.$router.push('login');
      this.token.value = this.$route.params.token;
      this.$refs.spinner.show();
      axios.get(`${this.$config.app_api.host}${this.$config.app_api.prefix}password/find/${this.token.value}`)
        .then((response) => {
          this.token.status = 'ok';
          this.email = response.data.email;
        })
        .catch((e) => {
          this.token.status = 'invalid';
          console.error(e.message);
        })
        .finally(() => {
          this.$refs.spinner.hide();
        });
    },
    resetPassword() {
      if (this.loading) return;
      if (!this.isFormValid()) return;
      this.loading = true;
      axios.post(`${this.$config.app_api.host}${this.$config.app_api.prefix}password/reset`, {
        email: this.email,
        password: this.newPass,
        password_confirmation: this.newPassConfirm,
        token: this.token.value,
      },
      {
        headers: {
          'Content-Type': 'application/json; charset=UTF-8',
          Accept: 'application/json',
        },
      })
        .then(() => {
          this.$router.push('/login');
        })
        .catch((e) => {
          this.errors = e.message;
          console.error(e.message);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// ResetPassword.vue?05b795ac